import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanMatchFn, Router } from '@angular/router';
import { PlatformService, RemoteConfigService } from '@ld.consumer-portal/utils';
import { filter, firstValueFrom } from 'rxjs';

// Native launch is servicing-only until the app-wide remote flag flips on: deep links
// into origination routes fall back to the dashboard while show_origination is off.
// On web isNativeMobile() is false so the flag is never consulted.
// Kept in canMatch (not canActivate): matching runs before activation guards, so the
// redirect short-circuits before originationAuthGuard / wizardResumeGuard can mutate
// session state (CP login, borrower context, saved wizard progress).
export const originationVisibilityGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const platformService = inject(PlatformService);
  const remoteConfigService = inject(RemoteConfigService);

  if (!platformService.isNativeMobile()) {
    return true;
  }

  if (!remoteConfigService.isInitialized()) {
    await firstValueFrom(toObservable(remoteConfigService.isInitialized).pipe(filter(Boolean)));
  }

  if (!remoteConfigService.config().show_origination) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
